import { FC } from 'react';
import styles from './badge.module.scss';

type BadgeProps = {
  backgroundColor?: string;
  color?: string;
  text: string;
};

export const Badge: FC<BadgeProps> = ({ text, backgroundColor, color }) => {
  return (
    <div className={styles.badge} style={{ backgroundColor }}>
      <label style={{ color }}>{text}</label>
    </div>
  );
};
